import React, { useState, useEffect } from 'react';
import { CyDModal } from '../CyDWrappers/modal';
import { IoClose } from 'react-icons/io5';
import Select from 'react-select';
import axios from 'axios';
import { AppImages } from '../../assets/s3';
import { redirect } from '../../util';
import { RedirectURLs } from '../../constants/redirectURLS';
import { useSearchParams } from 'react-router-dom';

export default function SignUpNowModal({ showModal, setShowModal }) {
  const [countries, setCountries] = useState([]);
  const [signupStatus, setSignupStatus] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState();
  const [email, setEmail] = useState('');
  const [searchParams] = useSearchParams();

  useEffect(() => {
    void getCountries();
  }, []);

  const getCountries = async () => {
    const response = await axios.get(
      'https://public.cypherd.io/js/countryMaster.js'
    );
    if (response.data) {
      setCountries(response.data);
    }
  };

  const signupForcard = async () => {
    if (!!selectedCountry && !!email) {
      setSignupStatus('loading');
      const origin = searchParams.get('ref');
      const response = await axios.post(
        'https://arch.cypherd.io/v1/cards/waitlist',
        {
          email,
          country: selectedCountry.value,
          ...(origin && { origin }),
        }
      );
      if (response.status === 201) {
        setSignupStatus(true);
      } else {
        setSignupStatus(false);
      }
    }
  };

  const customStyles = {
    menuList: (provided, state) => ({
      ...provided,
      height: '200px',
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      appearance: 'none',
      border: 'none',
      borderRadius: '0.475rem',
      fontSize: '0.875rem',
      width: '100%',
      paddingTop: '0.75rem',
      paddingBottom: '0.75rem',
      paddingLeft: '0.75rem',
      paddingRight: '0.75rem',
      color: '#4a5568',
      lineHeight: 1,
      outline: 'none',
    }),
  };

  return (
    <CyDModal showModal={showModal} setShowModal={setShowModal}>
      <div className='bg-[#ffffff] w-[448px] h-[452px] rounded-[16px]'>
        <div className='flex flex-col items-center'>
          <div className='flex flex-row w-full justify-between p-6'>
            <p className='text-lg'>Sign up for Cypher Card</p>
            <IoClose
              className='h-6 w-6 cursor-pointer'
              onClick={() => setShowModal(false)}
            />
          </div>
          <div className='h-[1px] w-full bg-[#D9D9D9]' />
          {!signupStatus || signupStatus === 'loading' ? (
            <div className='flex flex-col w-[98%] p-6'>
              <p className='text-xs text-[#6B778C] mb-1.5'>Select Country</p>
              <Select
                value={selectedCountry}
                class='py-4 px-4 rounded-[8px]'
                placeholder='Select country *'
                onChange={(e) => {
                  if (e) {
                    setSelectedCountry(e);
                  }
                }}
                isSearchable={true}
                options={countries.map((country) => {
                  return { value: country.Iso2, label: country.name };
                })}
                styles={customStyles}
              />
              <p className='text-xs text-[#6B778C] mt-4 mb-1.5'>
                Email Address
              </p>
              <div className='mb-4'>
                <input
                  type='email'
                  id='email'
                  name='email'
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  className='appearance-none border rounded-md text-sm w-full py-4 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
                  placeholder='Your Primary Email Address *'
                  required
                />
              </div>
              <p className='text-xs text-[#98A1B0] mb-6'>
                Your journey begins here! Keep an eye on your inbox for your
                account activation.
              </p>
              <button
                type='submit'
                onClick={() => {
                  void signupForcard();
                }}
                className='bg-[#FFDE59] w-full font-bold py-3 px-12 rounded focus:outline-none focus:shadow-outline self-center text-sm cursor-pointer'
              >
                {signupStatus === 'loading' ? 'Please wait...' : 'Signup'}
              </button>
              <a
                href='/business'
                className='underline text-xs text-[#98A1B0] mt-6 text-center'
              >
                Looking for business solution?
              </a>
            </div>
          ) : (
            <div className='flex flex-col items-center mt-6'>
              <img
                src={AppImages.SIGNUP_SUCCESS}
                className='h-[158px] w-[158px]'
              />
              <p className='text-base text-center mt-3 font-semibold'>
                Welcome aboard!🎉
                <br />
                Your invitation has been sent to your email.
                <br /> Use the invitation code to get started with <br /> Cypher
                Card.
              </p>
              <button
                className='font-bold py-[13px] bg-[#FFDE59] rounded-[8px] w-[400px] mt-3'
                onClick={() => {
                  redirect(RedirectURLs.dApp);
                }}
              >
                Login with dApp
              </button>
            </div>
          )}
        </div>
      </div>
    </CyDModal>
  );
}
